module.exports = __webpack_public_path__ + "img/page02_logo.4595fa3d.png";